import { createReducer, on, Action } from '@ngrx/store';
import * as OrderActions from './orders.actions';
import { cloneDeep } from 'lodash';
// import Stripe from 'stripe';
import { IInvoice, IOrder, IPaymentMethod } from '@care-portals/api-interfaces';

export const ORDERS_FEATURE_KEY = 'orders';

export interface State {
  orderDetails: {
    data: IOrder;
    loading: boolean;
    error: string;
    pay: {
      modal: boolean;
      loading: boolean;
      invoice: IInvoice;
      payment_method: IPaymentMethod;
      error: string;
    };
  };
  currentOrder: {
    data: any;
    loading: boolean;
    error: string;
  };
  orderModal: {
    data: any;
    loading: boolean;
    visible: boolean;
    error: string;
  };
  ordersHistory: {
    data: any;
    loading: boolean;
    error: string;
  };
  subscriptions: {
    data: any;
    loading: boolean;
    error: string;
  };
}

const initialState: State = {
  orderDetails: {
    data: null,
    loading: false,
    error: '',
    pay: {
      invoice: null,
      loading: false,
      modal: false,
      payment_method: null,
      error: ''
    }
  },
  currentOrder: {
    data: null,
    loading: false,
    error: ''
  },
  orderModal: {
    data: null,
    loading: false,
    visible: false,
    error: ''
  },
  ordersHistory: {
    data: null,
    loading: false,
    error: ''
  },
  subscriptions: {
    data: null,
    loading: false,
    error: ''
  }
};

const _reducer = createReducer(
  { ...initialState },

  /* -------------------------------------------------------------------------- */
  /*                                 Order Details                              */
  /* -------------------------------------------------------------------------- */
  on(OrderActions.openOrderDetails, (state: State) => {
    const _state = cloneDeep(state);
    _state.orderDetails.loading = true;
    return _state;
  }),
  on(OrderActions.openOrderDetailsSuccess, (state: State, { orderDetails }) => {
    const _state = cloneDeep(state);
    _state.orderDetails.loading = false;
    _state.orderDetails.data = orderDetails;
    _state.orderDetails.error = '';
    return _state;
  }),
  on(OrderActions.openOrderDetailsFailure, (state: State, { error }) => {
    const _state = cloneDeep(state);
    _state.orderDetails.data = null;
    _state.orderDetails.loading = false;
    _state.orderDetails.error = error.message;
    return _state;
  }),


  /* -------------------------------------------------------------------------- */
  /*                              Pay Order Modal                               */
  /* -------------------------------------------------------------------------- */
  on(OrderActions.openOrderPayModal, (state: State) => {
    const _state = cloneDeep(state);
    _state.orderDetails.pay.modal = true;
    return _state;
  }),
  on(OrderActions.closeOrderPayModal, (state: State) => {
    const _state = cloneDeep(state);
    _state.orderDetails.pay.modal = false;
    return _state;
  }),

  /* -------------------------------------------------------------------------- */
  /*                                 Order Modal                                */
  /* -------------------------------------------------------------------------- */
  on(OrderActions.openOrdersModal, (state: State) => {
    const _state = cloneDeep(state);
    _state.orderModal.loading = true;
    return _state;
  }),
  on(OrderActions.openOrdersModalSuccess, (state: State, { modalData }) => {
    const _state = cloneDeep(state);
    _state.orderModal.loading = false;
    _state.orderModal.data = modalData;
    _state.orderModal.visible = true;
    _state.orderModal.error = '';
    return _state;
  }),

  on(OrderActions.closeOrdersModal, (state: State) => {
    const _state = cloneDeep(state);
    _state.orderModal.loading = false;
    _state.orderModal.data = null;
    _state.orderModal.visible = false;
    _state.orderModal.error = '';
    return _state;
  }),

  /* -------------------------------------------------------------------------- */
  /*                               Orders History                               */
  /* -------------------------------------------------------------------------- */
  on(OrderActions.getOrders, (state: State) => {
    const _state = cloneDeep(state);
    _state.ordersHistory.loading = true;
    return _state;
  }),
  on(OrderActions.getOrdersSuccess, (state: State, { orderHistory }) => {
    const _state = cloneDeep(state);
    _state.ordersHistory.loading = false;
    _state.ordersHistory.data = orderHistory;
    _state.ordersHistory.error = '';
    return _state;
  }),
  on(OrderActions.getOrdersFailure, (state: State, { error }) => {
    const _state = cloneDeep(state);
    _state.ordersHistory.loading = false;
    _state.ordersHistory.error = error.message;
    return _state;
  }),

);

export function reducer(state: State, action: Action) {
  return _reducer(state, action);
}
